import { render, staticRenderFns } from "./Replenishment.vue?vue&type=template&id=45f925c8&scoped=true&"
import script from "./Replenishment.vue?vue&type=script&lang=js&"
export * from "./Replenishment.vue?vue&type=script&lang=js&"
import style0 from "./Replenishment.vue?vue&type=style&index=0&id=45f925c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f925c8",
  null
  
)

export default component.exports